import {
  Address as IconAddress,
  // SavedPlace as IconSavePlace,
  FrequentUsed as IconFrequentUsed,
} from '@ahamove/icons/map';

import { FeatureTypePlace, getAddressLabels } from '@ahm/api-wrappers-core';
import { useAuth } from '@ahm/react-auth';
import { ActionIcon, Combobox } from '@mantine/core';
import classes from '../address-autocomplete.module.css';
import { AddressAutocompleteItem } from '../autocomplete-item';
import type { AddressOptionsProps } from '../types';
import IconPencil from '@/assets/icons/pencil-icon.svg';
import IconSavePlace from '@/assets/icons/save-blue-icon.svg';
import SaveIcon from '@/assets/icons/save-white-icon.svg';

import { SavedPlaceForm } from '@/components/address-autocomplete/form';
import { useGetUserPlace } from '@/components/address-autocomplete/form/use-get-user-place';
import { AutocompleteModalId } from '@/components/address-autocomplete/modals/constants';
import useAutocompleteModal from '@/components/address-autocomplete/modals/use-autocomplete-modal';

import { MAX_NUMBER_OF_USER_PLACE } from '@/lib/constants';

const IconByFeatureType = (type?: string) => {
  if (type === FeatureTypePlace.FAVORITE_LOCATION) {
    return <IconSavePlace size={16} />;
  }
  if (type === FeatureTypePlace.RECENT_LOCATION) {
    return <IconFrequentUsed width={24} height={24} />;
  }

  return <IconAddress width={24} height={24} />;
};

const SearchAddressOptions = ({
  currentInputValue,
  options = [],
}: AddressOptionsProps) => {
  const { status } = useAuth();
  const { data: userPlaces } = useGetUserPlace({
    enabled: status === 'authenticated',
  });

  const { openModal } = useAutocompleteModal();

  const handleEditSavedPlace = (e: React.MouseEvent, addr) => {
    e.stopPropagation();

    const selectedSavePlace = userPlaces?.find((item) => {
      return (
        item?.type === FeatureTypePlace.FAVORITE_LOCATION &&
        addr?.code?.includes(item?.code)
      );
    });
    openModal({
      modalId: AutocompleteModalId.NEW_SAVED_PLACED,
      modalContent: (
        <SavedPlaceForm
          initData={selectedSavePlace ?? addr}
          isNewSavePlace={!selectedSavePlace}
        />
      ),
    });
  };

  const RightSectionByFeatureType = (addr) => {
    if (addr?.feature_type === FeatureTypePlace.FAVORITE_LOCATION) {
      return (
        <ActionIcon size={22} variant="white">
          <IconPencil onClick={(e) => handleEditSavedPlace(e, addr)} />
        </ActionIcon>
      );
    }

    if (userPlaces && userPlaces.length < MAX_NUMBER_OF_USER_PLACE)
      return (
        <ActionIcon size={22} variant="white">
          <SaveIcon w onClick={(e) => handleEditSavedPlace(e, addr)} />
        </ActionIcon>
      );
  };

  return (
    <>
      {(options ?? []).map((addr, idx) => {
        const [firstLabel] = getAddressLabels(addr.address);

        return (
          <Combobox.Option
            className={classes.option}
            style={{
              marginLeft: addr.isEntrance ? 36 : 0,
            }}
            title={addr.address}
            value={addr.address}
            key={`${idx}_${!addr.lat || !addr.lng ? `${addr.lat}_${addr.lng}` : addr.place_id}`}
          >
            <AddressAutocompleteItem
              hls={currentInputValue}
              primary={addr.first_label ?? firstLabel}
              secondary={
                addr.isEntrance && addr.second_label
                  ? addr.second_label
                  : addr.address
              }
              isEntrance={addr.isEntrance}
              icon={IconByFeatureType(addr?.feature_type)}
              rightSection={RightSectionByFeatureType(addr)}
            />
          </Combobox.Option>
        );
      })}
    </>
  );
};

export default SearchAddressOptions;
